import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import school from "../assets/school.png";

const Hero = () => {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    fetch("https://njinternational.ilakshyaerp.in/api/slider")
      .then((res) => res.json())
      .then((data) => setSlides(Array.isArray(data) ? data : []))
      .catch((err) => console.log("Slider Error:", err));
  }, []);

  return (
    <div className="hero-container">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        speed={1800}
        loop={true}
        className="hero-swiper"
      >

        {/* ✅ STATIC SLIDE (ALWAYS SHOW) */}
        <SwiperSlide>
          <div
            className="hero-slide"
            style={{
              backgroundImage: `url(${school})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="hero-overlay"></div>

            <div className="hero-center-box">
              <h1>NAV JEEVAN MISSION INTERNATIONAL SCHOOL</h1>
              <h2>NAV JEEVAN NAGAR, MEDICAL COLLEGE ROAD, GULHARIYA, GORAKHPUR(U.P.)</h2>
              <p>ARISE AND SHINE</p>
            </div>
          </div>
        </SwiperSlide>

        {/* ✅ DYNAMIC SLIDES FROM DATABASE */}
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="hero-slide"
              style={{
                backgroundImage: `url(https://njinternational.ilakshyaerp.in/uploads/slider/${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >

            </div>
          </SwiperSlide>
        ))}

      </Swiper>
    </div>
  );
};

export default Hero;